import { appNameMap } from "../constants/products.js";
const getHostingApp = (viewTypeOrPath)=>{
    if (viewTypeOrPath && Object.values(appNameMap).some((types)=>types[0] === viewTypeOrPath)) return viewTypeOrPath;
    if ('undefined' == typeof window) return;
    const pathname = 'string' == typeof viewTypeOrPath ? viewTypeOrPath : window?.location?.pathname ?? '/';
    if ('/' === pathname || pathname.startsWith('/home') || pathname.startsWith('/hotels') || pathname.startsWith('/flights') || pathname.startsWith('/vacationpackages') || pathname.startsWith('/vip')) return appNameMap["next-landing"]["0"];
    if (pathname.startsWith('/relax')) return pathname.includes('/at/') ? appNameMap["relax-at"]["0"] : appNameMap.relax["0"];
    if (pathname.startsWith('/m/fly/search')) return appNameMap["fly-search"]["0"];
    if (pathname.startsWith('/drive/landing') || pathname.startsWith('/rentalcars') || pathname.startsWith('/car-rentals') || pathname.startsWith('/rental-cars') || pathname.startsWith('/drive/search/r')) return appNameMap["drive-search-responsive"]["0"];
    if (pathname.startsWith('/cart/checkout')) return appNameMap["cart-checkout"]["0"];
    if (pathname.startsWith('/travel-itinerary')) return appNameMap["travel-itinerary"]["0"];
};
const getHostName = (IS_STORYBOOK, IS_CHROMATIC)=>{
    if ('undefined' == typeof window) return;
    let hostname = IS_STORYBOOK ? 'localhost:8080' : window?.location?.hostname ?? 'www.priceline.com';
    hostname = IS_CHROMATIC ? 'www.priceline.com' : hostname;
    const protocol = window?.location?.protocol ?? 'https:';
    return -1 !== hostname.indexOf('localhost') ? 'http://localhost:8080' : `${protocol}//${hostname}`;
};
export { getHostName, getHostingApp };
